import script from "./config-base.vue?vue&type=script&lang=jsx"
export * from "./config-base.vue?vue&type=script&lang=jsx"

import "./config-base.vue?vue&type=style&index=0&id=0f6277a3&lang=scss"
import "./config-base.vue?vue&type=style&index=1&id=0f6277a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6277a3"]])

export default __exports__